export const state = () => ({
    pageContents: [],
    selectedPageContent: {},
});
